import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Route, Redirect } from 'react-router-dom';

import { TemplateLayout } from 'components';

class CtTemplateLayout extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { path, isDetailView } = this.props;
    return <TemplateLayout currentPath={path.get('current')} beforePath={path.get('before')} />;
  }
}

const mapStateToProps = state => ({
  path: state.currentStatus.get('path'),
  isDetailView: state.currentStatus.get('isDetailView')
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CtTemplateLayout);



// WEBPACK FOOTER //
// ./src/script/containers/exam/CtTemplateLayout.js